import AuthToken from "../auth-token.tsx";

Whenever you make an API request, you need to authenticate using a token. A token is like a password that uniquely identifies your account and grants you access.

The following examples all expect your Replicate access token to be available from the command line. Because tokens are secrets, they should not be in your code. They should instead be stored in [environment variables](https://12factor.net/config). Replicate clients look for the `REPLICATE_API_TOKEN` environment variable and use it if available.

To set this up you can use:

<div className="not-prose">
  <AuthToken showDescription={false} token={props.token} type="shell" />
</div>

Some application frameworks and tools also support a text file named `.env` which you can edit to include the same token:

<div className="not-prose">
  <AuthToken showDescription={false} token={props.token} type="dotenv" />
</div>

The Replicate API uses the `Authorization` HTTP header to authenticate requests. If you’re using a [client library](https://replicate.com/docs/reference/client-libraries) this is handled for you.

You can test that your access token is setup correctly by using our [`account.get`](https://replicate.com/docs/reference/http#account.get) endpoint:

<aside>

<details>
<summary>What is cURL?</summary>

<div className="details-inner">

[cURL](https://en.wikipedia.org/wiki/CURL) is a command line tool for sending HTTP requests (same as your browser does) to a web server. It will show all the parts needed to make a similar request in the programming language of your choice, the URL, request headers and the request body. We’ve tried to keep these examples as clear as possible using tools that are commonly available on most computers.

</div>

</details>

</aside>

```bash
curl https://api.replicate.com/v1/account -H "Authorization: Bearer $REPLICATE_API_TOKEN"
# {"type":"user","username":"aron","name":"Aron Carroll","github_url":"https://github.com/aron"}
```

If it is working correctly you will see a JSON object returned containing some information about your account, otherwise ensure that your token is available:

```bash
echo "$REPLICATE_API_TOKEN"
# "r8_xyz"
```
